import {
    isCatalogueDisplayMode,
    TCPOS,
    VALIDATED_EXTENSION_FILE,
} from "@constants";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";

import React from "react";

import { getAlertActionButtonImageSrc } from "@helpers/general";

import { DynamicSvgComponent } from "@components/DynamicSvgComponent";
import { CartIconFilled } from "@components/OrderTaking/Components/Icons/CartIconFilled";
import ComposedProductCartPopup from "@components/OrderTaking/Components/Products/Cart/ComposedProductCartPopup";

import "./SalesModesChangeConfirmationDialog.css";
import useSalesModesChangeConfirmationDialog from "./SalesModesChangeConfirmationHook";

export function SalesModesChangeConfirmationModal({
    filledBasketIconContent,
    onClose,
    open,
}: SalesModesChangeConfirmationModalType): JSX.Element {
    const {
        t,
        handleModificationSalesMode,

        validateImageSrc,
        backImageSrc,
        newOrder,
        devise,
        newOrderItems,
        totalPrice,
        isPrm,
        actionsButtons,
    } = useSalesModesChangeConfirmationDialog();

    return (
        <Dialog
            onClose={onClose}
            open={open}
            container={() => document.querySelector(".fullscreen")}
            PaperProps={{
                sx: {
                    display: "flex!important",
                    gap: "5px!important",
                    alignItems: "center!important",
                    flexDirection: "column!important",
                    paddingTop: "0px!important",
                    paddingBottom: "0px!important",
                    color: "black!important",
                    height: isPrm ? "50%!important" : "90%!important",
                    width: "98%!important",
                    maxWidth: "unset!important",
                    maxHeight: "unset",
                    borderTop: `15px solid var(--global-color)!important`,
                    backgroundColor: "#FFFFFF!important",
                    borderRadius: "111px!important",
                    borderLeft: "1px solid #707070!important",
                    borderRight: "1px solid #707070!important",
                    borderBottom: "1px solid #707070!important",
                    top: isPrm ? "20%" : "unset",
                    right: "unset!important",
                    left: "unset!important",

                    zoom: `${isCatalogueDisplayMode() ? "50%" : "100%"}`,
                },
            }}
            style={{ backdropFilter: "blur(5px)" }}
        >
            <DialogTitle style={{ height: isPrm ? "50%" : "" }}>
                <div
                    className="d-flex justify-content-center align-items-center w-100"
                    style={{ height: isPrm ? "60%" : "" }}
                >
                    <img
                        alt="alert image"
                        className="sales-modes-changeConfirmation-dialog-alert-img"
                        src={getAlertActionButtonImageSrc(
                            actionsButtons as ActionsButtonsDesignType
                        )}
                    />
                </div>
                <div className="text-confirmed-alert">
                    <span>
                        {t("Your order will be modified")}.
                        <br /> {t("Do you want to continue ?")}
                    </span>
                </div>
            </DialogTitle>
            <div className="d-flex flex-column justify-content-start align-items-center w-100 sales-modes-changeConfirmation-dialog-order-container">
                {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    newOrder.map((product: any) => (
                        <ComposedProductCartPopup
                            key={product.iuudOrder}
                            product={product}
                            isSalesModeChange={true}
                        />
                    ))
                }
            </div>

            <div
                className="d-flex align-items-center justify-content-between w-100 px-4"
                style={{ backgroundColor: "#e3e3e3" }}
            >
                <div className="d-flex align-items-center p-1">
                    {filledBasketIconContent !== "" ? (
                        <div className="d-flex justify-content-start align-items-center h-100">
                            <img
                                src={filledBasketIconContent}
                                alt={filledBasketIconContent}
                                className="sales-modes-changeConfirmation-dialog-filled-basket"
                            />
                        </div>
                    ) : (
                        <CartIconFilled />
                    )}
                    <span
                        style={{
                            fontWeight: 600,
                            fontSize: "var(--font-size-body)",
                            lineHeight: "48px",
                            paddingLeft: "0.5rem",
                        }}
                    >
                        NOUVEAU PRIX :{" "}
                    </span>
                </div>

                <span
                    style={{
                        fontWeight: 600,
                        fontSize: "var(--font-size-subtitle)",
                        lineHeight: "35px",
                    }}
                >
                    {TCPOS
                        ? totalPrice.toFixed(devise.decimalPrice)
                        : newOrderItems.totalPrice.toFixed(
                              devise.decimalPrice
                          ) + ` ${devise.deviseSymbole}`}
                </span>
            </div>
            <DialogActions>
                <div
                    className="d-flex justify-content-center align-items-center pb-2"
                    style={{ gap: "15px", height: "10%" }}
                >
                    {backImageSrc !== "" ? (
                        <div className="mx-2" onClick={onClose}>
                            {VALIDATED_EXTENSION_FILE.includes(
                                backImageSrc.slice(-4)
                            ) ? (
                                <img
                                    src={backImageSrc}
                                    alt="backButton"
                                    style={{ height: "87px", width: "350px" }}
                                />
                            ) : (
                                <DynamicSvgComponent
                                    nameSvg={backImageSrc}
                                    width={"350px"}
                                    height={"87px"}
                                />
                            )}{" "}
                        </div>
                    ) : null}
                    {validateImageSrc !== "" ? (
                        <div
                            className="mx-2"
                            onClick={() => {
                                handleModificationSalesMode();
                            }}
                        >
                            {VALIDATED_EXTENSION_FILE.includes(
                                validateImageSrc.slice(-4)
                            ) ? (
                                <div
                                    style={{
                                        backgroundSize: " 100% 100%",
                                        backgroundImage: `url(${validateImageSrc})`,
                                        height: "87px",
                                        width: "350px",
                                    }}
                                />
                            ) : (
                                <DynamicSvgComponent
                                    nameSvg={validateImageSrc}
                                    width={"350px"}
                                    height={"87px"}
                                />
                            )}{" "}
                        </div>
                    ) : (
                        <img
                            alt="addToBasketButton"
                            src="./images/validate.png"
                            style={{ height: "87px", width: "350px" }}
                            onClick={() => {
                                handleModificationSalesMode();
                            }}
                        />
                    )}
                </div>
            </DialogActions>
        </Dialog>
    );
}
